export { GenericControlConnector, GenericControlConnectorAttrs } from "./GenericControlConnector";
